import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";
export const SAVE_OCR_FEEDBACK = "SVAE_OCR_FEEDBACK";

export const service = async (data) => {
  const options: object = {
    url: `/Api/Ocr/InsertFeedbackLog`,
    method: "POST",
    body: JSON.stringify(data),
    ...getDefaultOptions(),
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(SAVE_OCR_FEEDBACK, service, mock);
